// import { useState } from 'react';
// import FormCheckbox from 'src/components/Control/FormControls/FormCheckbox';
// import FormTextField from 'src/components/Control/FormControls/FormTextField';
import {
  FundraisingModel,
  FundraisingProductsInfo,
  FundraisingTicketingInfo,
  SendTicket,
  Step,
  TABS,
} from 'src/models/FundraisingModel';
import { FundraisingProps, renderHasChanged } from 'src/components/Pages/AddFundraisingPage';
import ChooseProducts from 'src/components/Elements/ChooseProducts';
import Button from '@material-ui/core/Button';
import { MouseEvent, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Store, useAppDispatch } from 'src/redux/Store';
import { ProductType } from 'src/models/ProductModel';
import {
  FaBoxOpen,
  FaDollarSign,
  FaHeart,
  FaTicketAlt,
} from 'react-icons/fa';
import ActionButton, { MENU_BUTTON_CATEGORY } from 'src/components/UI/ActionButton';
import ClearIcon from '@material-ui/icons/Clear';
import { FORM } from 'src/constants/Form';
import { ErrorBag } from 'src/models/ErrorModel';
import { setError } from 'src/redux/actions/errorsActions';
import { setAlert } from 'src/redux/actions/alertActions';
import { ALERT_TYPE } from 'src/constants/AlertType';
import FundraisingProductValidator from 'src/validations/FundraisingProductValidator';
import { t } from 'src/lib/language';
import FormCheckbox from 'src/components/Control/FormControls/FormCheckbox';
import Subtitle from 'src/components/UI/Subtitle';
import BottomRow from 'src/components/UI/BottomRow';
// eslint-disable-next-line import/no-extraneous-dependencies
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import ProductsSelector from 'src/components/Control/ProductsSelector';
import { formatMoney } from 'src/lib/MoneyHelper';
import { denormalizeFundraisingSection } from 'src/lib/FundraisingHelper';
import { FundraisingSections, FundraisingTypes } from 'src/constants/FundraisingTypes';
import FundraiserTitle from 'src/components/UI/FundRaiserTitle';
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from '@material-ui/core';
import FormTextField from 'src/components/Control/FormControls/FormTextField';
import Row from 'src/components/UI/Row';
import FormDateTimePicker from 'src/components/Control/FormControls/FormDateTimePicker';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';
import moment from 'moment-timezone-all';
import Scroller from 'src/components/UI/Scroller';

const FundraisingProductdForm = (props: FundraisingProps) => {
  const {
    onChange,
    setErrors,
    fundraisingState,
    setHasChanged,
    hasChanged,
  } = props;
  const dispatch = useAppDispatch();

  const products = useSelector((state: Store) => state.products);

  const getProductList = () => {
    if (fundraisingState?.products?.products) {
      return fundraisingState?.products?.products as number[];
    }
    return [] as number[];
  };

  const [productList, setProductList] = useState(getProductList());
  const [productInfoState, setProductInfoState] = useState({
    ...fundraisingState.products,
    show_suggested: fundraisingState?.fundraisingInfo?.show_suggested ?? false,
    ask_for_fee: fundraisingState?.fundraisingInfo?.ask_for_fee ?? false,
  } as FundraisingProductsInfo);

  const [ticketingState, setTicketingState] = useState<FundraisingTicketingInfo>(
    {
      send_ticket: SendTicket.all,
    } as FundraisingTicketingInfo,
  );

  const [openTicketing, setOpenTicketing] = useState(false);

  const errors: ErrorBag =
    useSelector((state: Store) => state.errors[FORM.fundraisingProducts] || {} as ErrorBag);

  useEffect(() => {
    if (!fundraisingState.products) return;
    setProductInfoState(fundraisingState.products);
  }, [fundraisingState]);

  useEffect(() => {
    dispatch(setError({ [FORM.fundraisingProducts]: {} }));
  }, []);

  const lang = useSelector((state: Store) => state.language.language);
  const fundraisingType = fundraisingState?.fundraisingInfo?.type;

  const showTicketing = () => {
    switch (fundraisingType) {
      case FundraisingTypes.matching:
      case FundraisingTypes.ticketing:
        return true;
      case FundraisingTypes.standard:
      default:
        return false;
    }
  };

  const getProductById = (id: number) => products.filter((product) => product.id === id)[0];

  const onTicketValueChange = (value: any, field: string) => {
    setHasChanged(true);
    setTicketingState({
      ...ticketingState,
      [field]: value,
    });
  };

  const onValueChange = (value: any, field: string) => {
    setHasChanged(true);
    setProductInfoState({
      ...productInfoState,
      [field]: value,
    });
  };

  const onAddProduct = (id: number) => {
    if (!id || productList.includes(id)) return;
    const newProductList = [...productList, id];
    setProductList(newProductList);
    onValueChange(newProductList, 'products');
  };

  const onDragEnd = (dropResult: any) => {
    const {
      destination,
      source,
    } = dropResult;
    // dropped outside the list
    if (!destination) return;

    const newProductList = Array.from(productList);
    const [removed] = newProductList.splice(source.index, 1);
    newProductList.splice(destination.index, 0, removed);
    setProductList(newProductList);
    onValueChange(newProductList, 'products');
  };

  const onRemoveProduct = (index: number) => {
    const newProductList = Array.from(productList);
    newProductList.splice(index, 1);
    setProductList(newProductList);
    onValueChange(newProductList, 'products');
  };

  const getIcon = (productType: ProductType = ProductType.product) => {
    switch (productType) {
      case ProductType.ticket:
        return (<FaTicketAlt />);
      case ProductType.donation:
        return (<FaHeart />);
      case ProductType.fee:
        return (<FaDollarSign />);
      default:
        return (<FaBoxOpen />);
    }
  };

  const renderPercent = (value: number) => `${Math.round(value * 1000) / 10}%`;

  const renderMoney = (value: number) => formatMoney(value);

  const renderBoolean = (booleanValue: boolean) => (
    <span style={{
      height: '24px',
      marginTop: '6px',
    }}>
      {booleanValue ? <span>&#9989;</span> : <span>&#10060;</span>}
    </span>
  );

  const handleSubmit = (event: MouseEvent<HTMLElement>, advance: boolean) => {
    event.preventDefault();
    setErrors(TABS.products, false);
    const errorBag = {} as ErrorBag;
    dispatch(setError({ [FORM.fundraisingProducts]: {} }));
    try {
      FundraisingProductValidator()
        .validateSync(productInfoState, { abortEarly: false });
    } catch (validationErrors: any) {
      dispatch(setAlert({
        type: ALERT_TYPE.error,
        code: 'forms.group.validation_errors',
      }));
      validationErrors.inner.forEach((e: any) => {
        if (!errorBag[e.path]) {
          errorBag[e.path] = [];
        }
        errorBag[e.path].push(e.message);
      });
      // eslint-disable-next-line prefer-destructuring
      dispatch(setError({ [FORM.fundraisingProducts]: errorBag }));
      setErrors(TABS.products, true);
      return;
    }
    onChange(
      {
        ...fundraisingState,
        products: denormalizeFundraisingSection(FundraisingSections.products, productInfoState),
      } as FundraisingModel,
      Step.products,
      advance,
    );
  };

  const ListStyle = {
    listStyleType: 'none',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    padding: '0px',
  };

  const ItemStyle = {
    border: '1px solid #c8c8c8',
    borderRadius: '8px',
    height: '48px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '8px',
    padding: '8px',
    width: '1020px',
    backgroundColor: 'white',
  };

  return (
    <>
      <FundraiserTitle>Products</FundraiserTitle>
      <Scroller height="565px">
        <ChooseProducts onAdd={onAddProduct} />
        <Subtitle>{t(lang, 'forms.fundraising.products_list')}</Subtitle>
        {(errors.productList && !!errors.productList.length) && (
          <span style={{
            color: 'red',
            fontStyle: 'italic',
          }}>
            {errors.productList.join(',')}
          </span>
        )}
        <div style={{ width: '75%' }}>
          <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="droppable">
              {
                (provided: any) => (
                  <ul
                    {...provided.droppableProps}
                    ref={provided.innerRef}
                    style={ListStyle}>
                    {productList.map((id, index) => {
                      const currentProduct = getProductById(id);
                      return (
                        <Draggable
                          key={`product-${id}`}
                          draggableId={`${id}`}
                          index={index}>
                          {(providedDraggable: any) => (
                            <li
                              ref={providedDraggable.innerRef}
                              {...providedDraggable.draggableProps}
                              {...providedDraggable.dragHandleProps}
                              style={{
                                ...ItemStyle,
                                ...providedDraggable.draggableProps.style, // <-- merge!
                              }}>
                              {getIcon(currentProduct.type)}
                              <span style={{ width: '100%' }}>{currentProduct.name_en}</span>
                              <span>|</span>
                              <span
                                style={{ width: '300px' }}>Deductible: {renderPercent(currentProduct.deductible || 0)}
                              </span>
                              <span>|</span>
                              <span
                                style={{ width: '300px' }}>Price: {renderMoney(currentProduct.price || 0)}
                              </span>
                              <span>|</span>
                              <span
                                style={{ width: '300px' }}>Modifiable: {renderBoolean(currentProduct.is_modifiable || false)}
                              </span>
                              <span style={{
                                marginRight: 0,
                                marginLeft: 'auto',
                              }}>
                                <ActionButton
                                  variant="outlined"
                                  category={MENU_BUTTON_CATEGORY.action}
                                  onClick={() => onRemoveProduct(index)}
                                  sizeSmall>
                                  <ClearIcon />
                                </ActionButton>
                              </span>
                            </li>
                          )}
                        </Draggable>
                      );
                    })}
                    {provided.placeholder}
                  </ul>
                )
              }
            </Droppable>
          </DragDropContext>
        </div>
        <Subtitle>Options</Subtitle>
        <div style={{
          width: '75%',
          display: 'flex',
          marginTop: '8px',
        }}>
          <div style={{ width: '50%' }}>
            <FormCheckbox
              label="Allow quantity for fix priced products"
              name="fixed_price_allow_quantity"
              onChange={onValueChange}
              checked={!!productInfoState.fixed_price_allow_quantity} />
          </div>
          <div style={{ width: '50%' }}>
            <FormCheckbox
              label="Display all products in a dropdown"
              name="all_products_visible"
              onChange={onValueChange}
              checked={!!productInfoState.all_products_visible} />
          </div>
        </div>
        {showTicketing() && (
          <>
            <Subtitle>Ticketing</Subtitle>
            <Row>
              <FormCheckbox
                checked={openTicketing}
                label="Ticketing Information"
                name="ticketing_information"
                onChange={(value:boolean) => setOpenTicketing(value)} />
            </Row>
            { openTicketing && (
              <>
                <Row>
                  <FormControl>
                    <RadioGroup
                      row
                      aria-labelledby="send_ticket"
                      name="send_ticket"
                      value={ticketingState.send_ticket}
                      onChange={(e:any, value: string) => onTicketValueChange(value, 'send_ticket')}>
                      <FormControlLabel
                        value={SendTicket.none}
                        control={<Radio />}
                        label="Do not send ticket" />
                      <FormControlLabel
                        value={SendTicket.all}
                        control={<Radio />}
                        label="Send all ticket in one PDF" />
                      <FormControlLabel
                        value={SendTicket.separate}
                        control={<Radio />}
                        label="Send each ticket in a separate PDF" />
                    </RadioGroup>
                  </FormControl>
                </Row>
                <Row>
                  <div style={{ width: '75%' }}>
                    <FormTextField
                      form={FORM.fundraisingProducts}
                      label="Name of the event"
                      name="title"
                      onChange={onTicketValueChange}
                      value={ticketingState.title} />
                  </div>
                  <div style={{ width: '25%' }}>
                    <FormDateTimePicker
                      form={FORM.fundraisingInfo}
                      label="Event date"
                      name="event_date"
                      onChange={
                    (value: MaterialUiPickersDate) => onTicketValueChange(value, 'event_date')
                  }
                      value={ticketingState.event_date || moment()
                        .add(1, 'day')
                        .startOf('day')}
                      minDate={moment()
                        .add(1, 'day')
                        .startOf('day')}
                      showTime />
                  </div>
                </Row>
                <Row>
                  <div style={{ width: '75%' }}>
                    <FormTextField
                      form={FORM.fundraisingProducts}
                      label="Location Name"
                      name="location_name"
                      onChange={onTicketValueChange}
                      value={ticketingState.location_name} />
                  </div>
                </Row>
                <Row>
                  <div style={{ width: '75%' }}>
                    <FormTextField
                      form={FORM.fundraisingProducts}
                      label="Location Address"
                      name="location_address"
                      onChange={onTicketValueChange}
                      value={ticketingState.location_address} />
                  </div>
                </Row>
                <Row>
                  <div style={{ width: '75%' }}>
                    <FormTextField
                      form={FORM.fundraisingProducts}
                      label="Contact name"
                      name="contact_name"
                      onChange={onTicketValueChange}
                      value={ticketingState.contact_name} />
                  </div>
                </Row>
                <Row>
                  <div style={{ width: '50%' }}>
                    <FormTextField
                      form={FORM.fundraisingProducts}
                      label="Contact phone"
                      name="contact_phone"
                      onChange={onTicketValueChange}
                      value={ticketingState.contact_phone} />
                  </div>
                  <div style={{ width: '50%' }}>
                    <FormTextField
                      form={FORM.fundraisingProducts}
                      label="Contact email"
                      name="contact_email"
                      onChange={onTicketValueChange}
                      value={ticketingState.contact_email} />
                  </div>
                </Row>
                <Row>
                  <div style={{ width: '100%' }}>
                    <FormTextField
                      form={FORM.fundraisingProducts}
                      label="Footer message"
                      name="footer"
                      onChange={onTicketValueChange}
                      value={ticketingState.footer} />
                  </div>
                </Row>
              </>
            )}
          </>
        )}
        <Subtitle>Product to use as &#34;Administrative Fees&#34;</Subtitle>
        <div style={{
          width: '75%',
          display: 'flex',
          marginTop: '8px',
        }}>
          <ProductsSelector
            id="product_fee_id"
            form={FORM.fundraisingProducts}
            name="product_fee_id"
            onChange={(id) => onValueChange(id, 'product_fee_id')}
            value={productInfoState.product_fee_id as number} />
        </div>
        <Subtitle>Product to use as &#34;Suggested Amount&#34;</Subtitle>
        <div style={{
          width: '75%',
          display: 'flex',
          marginTop: '8px',
        }}>
          <ProductsSelector
            id="product_suggested_id"
            form={FORM.fundraisingProducts}
            name="product_suggested_id"
            onChange={(id) => onValueChange(id, 'product_suggested_id')}
            value={productInfoState.product_suggested_id as number} />
        </div>
        <BottomRow>
          <Button
            variant="contained"
            color="primary"
            onClick={(e) => handleSubmit(e, false)}
            key="submit-button">
            Save{renderHasChanged(!hasChanged)}
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={(e) => handleSubmit(e, true)}
            key="submit-button-next">
            Save{renderHasChanged(!hasChanged)} and Next Step
          </Button>
        </BottomRow>
      </Scroller>
    </>
  );
};

export default FundraisingProductdForm;
//
